import { lazy } from 'react';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense.tsx';

const PdpSharedFramingStatusLazyComponent = lazy(
    () => import(/* webpackChunkName: "PdpSharedFramingStatus" */ './PdpSharedFramingStatus.tsx')
);

export const PdpSharedFramingStatusLazy = props => (
    <ClientSuspense fallback="">
        <PdpSharedFramingStatusLazyComponent {...props} />
    </ClientSuspense>
);
